<template>
  <el-dialog class="userRules" center :visible="isShow" destroy-on-close :show-close="false" :modal="true" :close-on-press-escape = 'false'>
    <span slot="title" class="dialog-header">
      <span class="title">协议</span>
      <Icon class="close" type="big" name="el-icon-close" @click.native="onClose"></Icon>
    </span>
    <div class="content">
      <div class="title">光耀元（Shine Meta）用户协议（草案）</div>
      <div class="title1">更新时间：2022年3月14日</div>
      <div class="rule-content">
        <div class="title2">欢迎您来到光耀元。</div>
        <div class="rules">
          请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不进入光耀元。当您注册成功，无论是进入光耀元，还是在光耀元上发布任何内容（即「内容」），均意味着您（即「用户」）完全接受本协议项下的全部条款。
        </div>
        <div class="space"></div>
        <div class="title2">使用规则</div>
        <div class="rules">用户注册成功后，光耀元将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。</div>
        <div class="rules">用户须对在光耀元的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义发布任何信息；不得恶意使用注册帐号导致其他用户误认；否则光耀元有权立即停止提供服务，收回其帐号并由用户独自承担由此而产生的一切法律责任。</div>
        <div class="rules">用户直接或通过各类方式间接使用光耀元服务和数据的行为，都将被视作已无条件接受本协议全部内容；若用户对本协议的任何条款存在异议，请停止使用光耀元所提供的全部服务。</div>
        <div class="rules">光耀元是一个实景数据信息分享、传播及获取的平台，对于免费的项目，用户通过光耀元发表的信息为公开的信息，其他第三方均可以通过光耀元获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任；任何用户不愿被其他第三人获知的信息都不应该在光耀元上进行发表。</div>
        <div class="rules">用户承诺不得以任何方式利用光耀元直接或间接从事违反中国法律以及社会公德的行为，光耀元有权对违反上述承诺的内容予以删除。</div>
        <div class="rules">用户不得利用光耀元服务制作、上载、复制、发布、传播或者转载如下内容：</div>
        <div class="space"></div>
        <div class="title2">知识产权</div>
        <div class="rules">光耀元是一个实景三维信息数据获取、分享及传播的平台，我们尊重和鼓励光耀元用户创作的内容，认识到保护知识产权对光耀元生存与发展的重要性，承诺将保护知识产权作为光耀元运营的基本原则之一。</div>
        <div class="rules">用户在光耀元上发表的全部内容，著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要得到光耀元的同意。</div>
        <div class="rules">光耀元提供的网络服务中包含的标识、版面设计、排版方式、文本、图片、图形等均受著作权、商标权及其它法律保护，未经相关权利人（含光耀元及其他原始权利人）同意，上述内容均不得在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。</div>
        <div class="rules">在光耀元上传或发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益及国家相关法律法规。如果第三方提出关于著作权的异议，光耀元有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给光耀元或任何第三方造成损失的，用户应负责全额赔偿。</div>
        <div class="rules">如果任何第三方侵犯了光耀元用户相关的权利，用户同意授权光耀元或其指定的代理人代表光耀元自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在光耀元认为必要的情况下参与共同维权。</div>
        <div class="rules">光耀元有权但无义务对用户发布的内容进行审核，有权根据相关证据结合法律法规及光耀元社区指导原则对侵权信息进行处理。</div>
        <div class="space"></div>
        <div class="title2">个人隐私</div>
        <div class="rules">尊重用户个人隐私信息的私有性是光耀元的一贯原则，光耀元将通过技术手段、强化内部管理等办法充分保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或事先得到用户明确授权等原因外，光耀元保证不对外公开或向第三方透露用户隐私信息，或用户在使用服务时存储的非公开内容。同时，为了运营和改善光耀元的技术与服务，光耀元将可能会自行收集使用或向第三方提供用户的非个人隐私信息，这将有助于光耀元向用户提供更好的用户体验和服务质量。</div>
        <div class="space"></div>
        <div class="title2">免责声明</div>
        <div class="rules">光耀元不能对用户发布的数据的正确性进行保证。</div>
        <div class="rules">用户使用光耀元上传和分享的地图数据应符合《中华人民共和国测绘法》、《地图管理条例》及互联网地图管理的相关规定。用户使用光耀元上传和分享的地图数据不得表示的内容包括：危害国家统一、主权和领土完整；危害国家安全、损害国家荣誉和利益的；属于国家秘密的；影响民族团结、侵害民族风俗习惯的；法律、法规规定的不得表示的内容。</div>
        <div class="rules">用户在光耀元发表的内容仅表明其个体行为，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。光耀元不承担任何法律及连带责任。</div>
        <div class="rules">光耀元不保证网络服务一定能满足用户的要求，也不保证网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。</div>
        <div class="rules">对于因不可抗力或光耀元不能控制的原因造成的网络服务中断或其它缺陷，光耀元不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</div>
        <div class="space"></div>
        <div class="title2">协议修改</div>
        <div class="rules">根据互联网的发展和有关法律、法规及规范性文件的变化，或者因业务发展需要，光耀元有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，光耀元将会直接在光耀元网站上公布修改之后的协议内容，该公布行为视为光耀元已经通知用户修改内容。光耀元也可采用电子邮件或私信的传送方式，提示用户协议条款的修改、服务变更、或其它重要事项。</div>
        <div class="rules">如果不同意光耀元对本协议相关条款所做的修改，用户有权并应当停止使用光耀元。如果用户继续使用光耀元，则视为用户接受光耀元对本协议相关条款所做的修改。</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserRules',
  data () {
    return {
      isShow: false
    }
  },
  mounted () {

  },
  methods: {
    show (isShow) {
      this.isShow = isShow
    },
    onClose () {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss">
.userRules{
  .el-dialog{
    // box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.4);
    // background: #3D3E40;
    // border-radius: 6PX 6PX 6PX 6PX;
    // width: 1360px;
    // height: 880px;
    width: 1360px;
    height: 780px;
    background: #3D3E40;
    border: 1px solid #565759;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.8);
    border-radius: 10px;
    margin-top: 60px !important;
  }
  .el-dialog__header{
    background-color: $bg-color;
    padding: 2px;
    text-align: left;
    border-radius: 6PX 6PX 0 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .el-dialog__title{
      color: $font-colorf;
      font-size: $font-size16;
    }
  }
  .content {
    height: 685px;
    overflow-y: auto;
    line-height: 30px;
    .title{
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 30px;
      text-align: center;
    }
    .title1{
      font-size: 14px;
      color: #999999;
      text-align: center;
    }
    .rule-content{
      letter-spacing: 1px;
      margin: 30px 40px;
      color: #FFFFFF;
      .title2{
        font-size: 16px;
        font-weight: bold;
      }
      .rules{
        text-indent: 20px;
        font-size: 14px;
      }
      .space{
        height: 40px;
      }
    }
  }
  .el-dialog__body {
    background-color: $bg-color;
    padding: 15px 15px 10px 15px;
    border-radius: 0 0 6PX 6PX;
    .el-form-item__label {
      color: #999999;
    }
  }
  .dialog-header{
    height: 30px;
    line-height: 60px;
    .title{
      font-size: 16px;
      margin-left: 12px;
      color: #FFFFFF;;
    }
    .value{
      color: $font-colorf;
      margin-right: 30px;
    }
    .close{
      margin-top: 10px;
      float: right;
      margin-right: 1px;
    }
  }
  .cesium-widget{
    canvas{
      border-radius: 6px;
    }
  }
}
</style>
